import React, { useEffect, useState } from "react";
import { PageHeader, Card, Tag } from "../components/UI";
import { Sparkles, TrendingDown, TrendingUp, Users } from "lucide-react";
import api from "../lib/api";

function Section({ title, icon: Icon, items, tone }) {
  return (
    <Card title={title} subtitle={`AI-prioritized · ${items.length} targets`} action={<Tag tone={tone}><Icon size={11} /> Live</Tag>}>
      <table className="refined">
        <thead><tr><th>Physio</th><th>City</th><th>Engagement</th><th>Growth</th><th>Dormancy</th></tr></thead>
        <tbody>
          {items.map((p) => (
            <tr key={p.id}>
              <td className="font-medium">{p.first_name} {p.last_name}</td>
              <td>{p.city}</td>
              <td className="numerals">{Math.round(p.ai_scores?.engagement)}</td>
              <td className="numerals">{Math.round(p.ai_scores?.growth)}</td>
              <td className="numerals">{Math.round(p.ai_scores?.dormancy)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
}

export default function AIInsights() {
  const [d, setD] = useState(null);
  useEffect(() => { (async () => { const { data } = await api.get("/analytics/ai-insights"); setD(data); })(); }, []);
  if (!d) return <div className="text-slate-400 text-sm">Loading…</div>;

  return (
    <div className="space-y-6">
      <PageHeader
        kicker="Intelligence"
        title="AI Insights"
        subtitle="The CBC intelligence layer continuously scores every physiotherapist and produces recommended actions for HO, regional and DSE teams."
        testId="ai-insights-page"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        {d.summary_cards.map((c, i) => (
          <div key={i} className="ai-surface p-4">
            <div className="flex items-center gap-2 text-teal-900 font-medium text-[13px]"><Sparkles size={14} /> {c.title}</div>
            <p className="text-[12.5px] text-teal-900/80 mt-2 leading-relaxed">{c.body}</p>
          </div>
        ))}
      </div>

      <Section title="Churn risks" icon={TrendingDown} items={d.churn_risks} tone="rose" />
      <Section title="Milestone close — push these" icon={TrendingUp} items={d.milestone_close} tone="teal" />
      <Section title="Referral influencers" icon={Users} items={d.referral_influencers} tone="emerald" />
    </div>
  );
}
